import { Trans } from "react-i18next";

export default function AddedToCalendarEvent({ events, ownerChallenge }) {
  return (
    <Trans
      i18nKey="notifications.addedToCalendarEvent"
      values={{
        events: events
          .map((event) => event?.event.title || "[Deleted]")
          .join(" "),
        challenge: ownerChallenge?.name || "Deleted",
      }}
      components={{ b: <b />, span: <span /> }}
    />
  );
}
